import React, { useMemo, useState, useEffect } from "react";
import moment from "moment/moment";

export const WeatherInfoTemplate = `
  <style>
    .weather-widget-v2{
      background-color: {{bgColor}};
      background-image: url({{bgImg}});
      background-size: cover;
      background-repeat: no-repeat;
      background-position: center;
      position: relative; /* allow natural document flow */
      width: 100%;
      height: auto; /* grow to fit content */
      min-height: 100%;
      color: white;
      display: flex;
      justify-content: {{cssJustifyContent}};
      align-items: center;
      flex-direction: column;
      container-name: weather-widget-v2;
      container-type: inline-size;
      overflow: visible; /* ensure header/content not clipped */
      padding: 2cqh 0;
      box-sizing: border-box;
    }
    .weather-widget-v2-header{
        display: flex;
        align-items: center;
        flex-direction: column;
        width: 100%;
        padding: 0;
        flex-shrink: 0;
    }
    .weather-widget-v2-header h1{
        font-size: 2.5cqh; 
        margin: 2cqh 0 0 0;
    }
    .weather-widget-v2-header .current-temperature{
        font-size: 5cqh;
        margin: 1cqh 0;
    }
    .weather-widget-v2-header h1 img{
        width: 2.5cqh;
        height: 2.5cqh;
        vertical-align: middle;
    }
    .weather-widget-v2-header h3{
        font-size: 2cqh;
        margin: 0.5cqh 0;
    }
    .weather-widget-v2-header .weather-icon{
        width: 12cqh;
        height: 12cqh;
        margin: 1cqh 0;
    }
    .weather-widget-v2-header .weather-stats{
        display: flex;
        align-items: center;
        gap: 2cqh;
        margin-top: 1cqh;
    }
    .weather-widget-v2-header .weather-stats-item{
        display: flex;
        align-items: center;
        gap: 1cqh;
    }
    .weather-widget-v2-header .weather-stats-item img{
        width: 4cqh;
        height: 4cqh;
    }
    .weather-widget-v2-forecast{
      margin-top: 3cqh;
      background-color: rgba(135,206,250,.5);
      width: 90%;
      border-radius: 1.5cqh;
      display: flex;
      flex-direction: column;
      flex: 0 0 auto; /* size to content, not consume all height */
      min-height: 0;
      max-height: none;
      overflow: visible; /* allow inner items to be shown */
    }
    .weather-widget-v2-forecast .current-time{
        align-self: center;
        margin: 2cqh 0 2cqh;
        font-size: 2.5cqh;
        font-weight: 500;
        flex-shrink: 0;
    }
    .weather-widget-v2-forecast .forecast-grid{
        display: grid;
        grid-template-rows: repeat(6, minmax(0, 1fr));
        width: 100%;
        align-items: center;
        padding: 0 2cqh 2cqh 2cqh;
        gap: 1cqh;
      overflow: hidden;
        flex: 1;
        min-height: 0;
    }
    .weather-widget-v2-forecast .forecast-grid-item{
        height: 100%;
        min-height: 10cqh;
        display: grid;
        grid-template-columns: repeat(3, minmax(0, 1fr));
        align-items: center;
        text-align: center;
        font-size: 2.2cqh;
        font-weight: 500;
      padding: 1cqh 3cqh;
        border-radius: 2cqh;
    }
    /* Compact first (today) item to line height */
    .weather-widget-v2-forecast .forecast-grid-item:first-child{
      min-height: auto;
      height: auto;
      padding: 0.4cqh 3cqh;
      grid-template-columns: repeat(2, minmax(0,1fr));
    }
    .weather-widget-v2-forecast .forecast-grid-item:first-child img{
      display: none;
    }
    .weather-widget-v2-forecast .forecast-grid-item img{
        width: 6cqh;
        height: 6cqh;
        margin: 0 auto;
    }
    .weather-widget-v2-forecast .forecast-grid-item .forecast-time-mobile{
        text-align: left;
        display: block;
        margin: 1cqh;
    }
    .weather-widget-v2-forecast .forecast-grid-item .forecast-time-desktop{
        display: none;
    }
    .weather-widget-v2-forecast .forecast-grid-item .forecast-temperature{
        text-align: right;
        margin: 1cqh;
    }
    @container weather-widget-v2 (min-aspect-ratio: 9/16){
      .weather-widget-v2-header{
        padding: 1cqw 0;
      }
      .weather-widget-v2-header h1{
        font-size: 2cqw;
        margin: 1cqw 0 0 0;
      }
      .weather-widget-v2-header .current-temperature{
        font-size: 4cqw;
        margin: 0.5cqw 0;
      }
      .weather-widget-v2-header h1 img{
        width: 2cqw;
        height: 2cqw;
      }
      .weather-widget-v2-header h3{
        font-size: 1.5cqw;
        margin: 0.3cqw 0;
      }
      .weather-widget-v2-header .weather-icon{
        width: 8cqw;
        height: 8cqw;
        margin: 0.5cqw 0;
      }
      .weather-widget-v2-header .weather-stats{
        gap: 3cqw;
        margin-top: 0.5cqw;
      }
      .weather-widget-v2-header .weather-stats-item{
        gap: 0.8cqw;
      }
      .weather-widget-v2-header .weather-stats-item img{
        width: 3cqw;
        height: 3cqw;
      }
      .weather-widget-v2-forecast{
        background-color: rgba(135,206,250,.5);
        aspect-ratio: 3 / 1;
        width: 80%;
        margin: 4cqw auto 2cqw auto;
        max-height: none;
        border-radius: 1cqw;
      }
      .weather-widget-v2-forecast .current-time{
        margin: 1.5cqw 1.5cqw 0 0;
        align-self: flex-end;
        font-size: 1.8cqw;
      }
      .weather-widget-v2-forecast .forecast-grid{
        grid-template-rows: none;
        grid-template-columns: repeat(6, minmax(0, 1fr));
        padding: 0 1cqw;
        gap: 0.5cqw;
        overflow: hidden;
      }
      .weather-widget-v2-forecast .forecast-grid-item{
        height: auto;
        min-height: auto;
        grid-template-columns: none;
        font-size: 1.8cqw;
        padding: 1.5cqw 2cqw;
        border-radius: 1cqw;
        display: flex;
        flex-direction: column;
        justify-content: center;
      }
      .weather-widget-v2-forecast .forecast-grid-item:first-child{
        padding: 0.3cqw 2cqw;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
      }
      .weather-widget-v2-forecast .forecast-grid-item:first-child img{
        display: none;
      }
      .weather-widget-v2-forecast .forecast-grid-item img{
        width: 5cqw;
        height: 5cqw;
        margin: 0.5cqw auto;
      }
      .weather-widget-v2-forecast .forecast-grid-item .forecast-time-mobile{
        display: none;
      }
      .weather-widget-v2-forecast .forecast-grid-item .forecast-time-desktop{
        display: block;
        margin: 0.5cqw;
      }
      .weather-widget-v2-forecast .forecast-grid-item .forecast-temperature{
        text-align: center;
        margin: 0.5cqw;
      }
    }
  </style>
  <div class="weather-widget-v2">
    <div class="weather-widget-v2-header">
      <h1>
        <img src="/assets/icons/weather/location-sign.svg" />
        {{formattedAddress}}
      </h1>
      <img class="weather-icon" src="/assets/icons/weather/{{weatherIcon}}.svg" />
      <h1 class="current-temperature">{{temperature}}°{{scale}}</h1>
      <div class="weather-stats">
        <div class="weather-stats-item">
          <img src="/assets/icons/weather/humidity.svg" />
          <h3>{{humidity}}%</h3>
        </div>
        <div class="weather-stats-item">
          <img src="/assets/icons/weather/wind.svg" />
          <h3>{{pressure}} hPa</h3>
        </div>
      </div>
    </div>
    <div class="weather-widget-v2-forecast">
      <div class="current-time">
        {{currentTime}}
      </div>
      <div class="forecast-grid">
       {{forecast}}
      </div>
    </div>
  </div>
`;

export const ForecastItemTemplate = `
  <div class="forecast-grid-item" style="background: {{background}};">
    <p class="forecast-time-mobile">
        {{datetimeMobile}}
    </p>
    <p class="forecast-time-desktop">
        {{datetimeDesktop}}
    </p>
    <img src="/assets/icons/weather/{{weatherIcon}}.svg" />
    <p class="forecast-temperature">
      <span>{{maxTemperature}}°</span> - <span>{{minTemperature}}°</span>
    </p>
  </div>
`;

export const weatherThemeSettings = (themeValue) => {

  const images = {
    bg1: `/images/BG_1.jpeg`,
    bg2: `/images/BG_2.jpeg`,
  };

  switch (themeValue) {
    case "#808080":
      return { bgImg: images.bg1, bgColor: "#224e83" };
    case "#90EE90":
      return { bgImg: images.bg2, bgColor: "#6995c8" };
    default:
      return null;
  }
};

const API_KEY = "b589b102afcfbd7027b38ea5b816f17a";

export const getWeatherUrl = (lat, lng, lang, units) => `//api.openweathermap.org/data/2.5/weather?lat=${lat}&lon=${lng}&appid=${API_KEY}&lang=${lang}&units=${units}`;

export const getForecastUrl = (lat, lng, lang, units) => `//api.openweathermap.org/data/2.5/forecast?lat=${lat}&lon=${lng}&appid=${API_KEY}&lang=${lang}&units=${units}`;

const getWeather = async (lat, lng, lang, units) => {
  const currentWeatherURL = getWeatherUrl(lat, lng, lang, units);
  const currentWeatherResponse = await fetch(currentWeatherURL);
  const currentWeatherData = await currentWeatherResponse.json();

  const forecastURL = getForecastUrl(lat, lng, lang, units);
  const forecastResponse = await fetch(forecastURL);
  const forecastData = await forecastResponse.json();

  forecastData.list.unshift({
    dt_txt: moment().format('YYYY-MM-DD 15:00:00'),
    ...currentWeatherData,
  });

  return {
    current: currentWeatherData,
    forecast: forecastData
  };

}

const CardWeatherv2 = ({ item, style, cssOverflow, cssJustifyContent, compact, orientation = 'landscape' }) => {

  const [weatherData, setWeatherData] = useState(null);
  const weatherSettings = item.weather || item;
  
  useEffect(() => {
    getWeather(
      weatherSettings?.location?.lat ?? '40.730610',
      weatherSettings?.location?.lng ?? '-73.935242',
      weatherSettings?.language ?? 'en',
      weatherSettings?.scale == 'F' ? 'imperial' : 'metric'
    ).then(data => setWeatherData(data));
  }, [weatherSettings?.location, weatherSettings?.language, weatherSettings?.scale]);



  const previewHTML = useMemo(() => {
    if (weatherData == null)
      return "";

    const { current: currentWeather, forecast: forecastWeather } = weatherData;
    const theme = weatherThemeSettings(weatherSettings.theme);

    //Find newest forecast but not more that 15
    let forecastHTML = forecastWeather.list.reduce((forecast, item) => {
      const itemMoment = moment(item.dt_txt);
      const dayIndex = forecast.findIndex(i => {
        const iMoment = moment(i.dt_txt);
        return iMoment.day() == itemMoment.day();
      });

      if (dayIndex < 0) {
        forecast.push(item);
      } else {
        const forecastDayMoment = moment(forecast[dayIndex].dt_txt);
        if (itemMoment.hour() > forecastDayMoment.hour() && itemMoment.hour() <= 15) {
          forecast[dayIndex] = item;
        }
      }

      return forecast;
    }, []).map((weather) => {
      const weatherIcon = weather.weather?.[0]?.icon || weather.weather?.[0]?.icon || currentWeather.weather[0].icon;
      return ForecastItemTemplate
        .replace("{{datetimeMobile}}", moment(weather.dt_txt).startOf('day').isSame(moment().startOf('day')) ? "Today" : moment(weather.dt_txt).format('DD dddd'))
        .replace("{{datetimeDesktop}}", moment(weather.dt_txt).startOf('day').isSame(moment().startOf('day')) ? "Today" : moment(weather.dt_txt).format('dd DD'))
        .replace("{{weatherIcon}}", weatherIcon.replace(/[dn]/, ''))
        .replace("{{maxTemperature}}", Math.ceil(weather.main.temp_max))
        .replace("{{minTemperature}}", Math.floor(weather.main.temp_min))
        .replace("{{background}}", moment(weather.dt_txt).startOf('day').isSame(moment().startOf('day')) ? "rgba(0,162,232,0.5)" : "none");
    }).join('')

    const effectiveOverflow = compact ? 'auto' : (cssOverflow ? cssOverflow : 'auto');
    const effectiveJustify = compact ? 'flex-start' : (cssJustifyContent ? cssJustifyContent : "center");

    // Add orientation class to forecast grid
    let orientationClass = '';
    if (orientation === 'landscape') {
      orientationClass = 'forecast-grid-landscape';
    } else {
      orientationClass = 'forecast-grid-portrait';
    }

    // Inject orientation class into forecast grid
    let html = WeatherInfoTemplate
      .replace('<div class="forecast-grid">', `<div class="forecast-grid ${orientationClass}">`)
      .replace("{{bgColor}}", theme.bgColor)
      .replace("{{bgImg}}", theme.bgImg)
      .replace("{{forecast}}", forecastHTML)
      .replace("{{formattedAddress}}", weatherSettings?.location?.formattedAddress ?? currentWeather.name)
      .replace("{{weatherIcon}}", currentWeather.weather[0].icon.replace(/[dn]/, ''))
      .replace("{{temperature}}", Math.round(currentWeather.main.temp))
      .replace("{{humidity}}", currentWeather.main.humidity)
      .replace("{{pressure}}", currentWeather.main.pressure)
      .replace("{{currentTime}}", moment().format('hh:mm A dddd, MMM DD'))
      .replace("{{cssOverflow}}", effectiveOverflow)
      .replace("{{cssJustifyContent}}", effectiveJustify)
      .replaceAll("{{scale}}", weatherSettings.scale)

    // Add extra CSS for orientation
    const orientationCss = `
      <style>
        .forecast-grid-landscape {
          display: grid !important;
          grid-template-rows: none !important;
          grid-template-columns: repeat(6, minmax(0, 1fr)) !important;
          flex-direction: row !important;
          overflow-x: auto;
          overflow-y: hidden;
        }
        .forecast-grid-portrait {
          display: grid !important;
          grid-template-columns: none !important;
          grid-template-rows: repeat(6, minmax(0, 1fr)) !important;
          flex-direction: column !important;
          overflow-y: auto;
          overflow-x: hidden;
        }
      </style>
    `;
    html = html.replace('</style>', `${orientationCss}</style>`);

    if (compact) {
      const extraCss = `
        <style>
          .weather-widget-v2-header{ padding: 1cqh 0; }
          .weather-widget-v2-header h1{ margin: 1cqh 0 0 0; font-size: 2cqh; }
          .weather-widget-v2-header .current-temperature{ font-size: 4cqh; margin: 0.5cqh 0; }
          .weather-widget-v2-header .weather-icon{ width: 10cqh; height: 10cqh; }
          .weather-widget-v2-forecast{ margin-top: 2cqh; width: 95%; }
          .weather-widget-v2-forecast .forecast-grid-item{ min-height: 8cqh; padding: 0 1cqh; }
          .weather-widget-v2-forecast .forecast-grid-item img{ width: 5cqh; height: 5cqh; }
          @container weather-widget-v2 (min-aspect-ratio: 9/16){
            .weather-widget-v2-header{ padding: 0.8cqw 0; }
            .weather-widget-v2-header h1{ font-size: 1.8cqw; margin: 0.8cqw 0 0 0; }
            .weather-widget-v2-header .current-temperature{ font-size: 3.5cqw; }
            .weather-widget-v2-header .weather-icon{ width: 7cqw; height: 7cqw; }
            .weather-widget-v2-forecast{ aspect-ratio: auto; width: 90%; margin: 3cqw auto 2cqw auto; }
            .weather-widget-v2-forecast .forecast-grid-item{ font-size: 1.5cqw; padding: 0.8cqw; }
          }
        </style>
      `;
      html = html.replace('</style>', `${extraCss}</style>`);
    }

    return html;
  }, [weatherData, item, orientation]);

  return (
    <div style={{ ...style, position: 'relative', width: '100%', height: '100%' }} dangerouslySetInnerHTML={{ __html: previewHTML }} />
  );
};

export default CardWeatherv2;
